import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=49031988&"
import script from "./PersonalInformation.vue?vue&type=script&lang=js&"
export * from "./PersonalInformation.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInformation.vue?vue&type=style&index=0&id=49031988&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports